var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import SFormControl from '../SFormControl';
import InputLabel from '../InputLabel';
import { LabelPlacement } from '../Form/FormInputProps';
import { FormHelperText, OutlinedInput } from '@mui/material';
import { styled } from '@mui/system';
//See instructions on how to mae custom field: https://mui.com/x/react-date-pickers/custom-field/#customize-the-default-field
var InputWrapper = styled('div')({
    flexGrow: 1,
    margin: 0,
});
var SOutlinedInput = styled(OutlinedInput)({
    width: '100%',
});
/**
 * This component is used to wrap the date picker component in a form control.
 */
export var DateFormControl = React.forwardRef(function (props, inputRef) {
    var disabled = props.disabled, id = props.id, label = props.label, _a = props.required, required = _a === void 0 ? false : _a, _b = props.labelPlacement, labelPlacement = _b === void 0 ? LabelPlacement.TOP : _b, boldLabel = props.boldLabel, optional = props.optional, errorMessage = props.errorMessage, hintMessage = props.hintMessage, _c = props.insets, insets = _c === void 0 ? false : _c, formControlSx = props.formControlSx, className = props.className, _d = props.InputProps, _e = _d === void 0 ? {} : _d, containerRef = _e.ref, startAdornment = _e.startAdornment, endAdornment = _e.endAdornment, 
    //not used
    ownerState = props.ownerState, 
    //@ts-ignore
    focused = props.focused, other = __rest(props, ["disabled", "id", "label", "required", "labelPlacement", "boldLabel", "optional", "errorMessage", "hintMessage", "insets", "formControlSx", "className", "InputProps", "ownerState", "focused"]);
    var error = !!errorMessage || !!(props === null || props === void 0 ? void 0 : props.error);
    var helperText = errorMessage || hintMessage;
    return (React.createElement(SFormControl, __assign({ ref: containerRef, id: id, sx: formControlSx }, { error: error, required: required, insets: insets, labelPlacement: labelPlacement, className: className }),
        label && (React.createElement(InputLabel, __assign({}, { boldLabel: boldLabel, optional: optional, labelPlacement: labelPlacement, required: required }), label)),
        React.createElement(InputWrapper, null,
            React.createElement(SOutlinedInput, __assign({ inputRef: inputRef }, { startAdornment: startAdornment, endAdornment: endAdornment, disabled: disabled }, other, { error: error })),
            helperText && React.createElement(FormHelperText, null, helperText))));
});
// @ts-ignore
DateFormControl.displayName = 'DateFormControl';
